export const title = 'Faturamento total';
import CampaignAttributionDateNote from '../../shared/partials/campaign-attribution-date-note.pt.mdx';

Faturamento total gerado por vendas atribuídas a campanhas.

<CampaignAttributionDateNote />
